import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import pictureHelper from "helpers/picture"

import styles from "./tilePerson.css"

const TilePerson = ({ tile }) => {
  const title = tile.getTitle()
  const subtitle = tile.getSubtitle()
  const image = tile.getImageUrl("profile", "medium")

  return (
    <article className={classnames(styles.root)} itemScope itemType="https://schema.org/Person">
      <div className={styles.imageWrapper}>
        {image ? (
          <img className={styles.image} src={pictureHelper.replaceProtocol(image)} alt={`${title} - ${subtitle}`} itemProp="image" loading="lazy" />
        ) : (
          <div className={styles.placeholder}>
            <span>{tile.getPlaceholder()}</span>
          </div>
        )}
      </div>
      <div>
        {title && <p className={styles.title} itemProp="name" dangerouslySetInnerHTML={{ __html: title }} />}
        {subtitle && <p className={styles.subtitle} itemProp="jobTitle" dangerouslySetInnerHTML={{ __html: subtitle }} />}
      </div>
    </article>
  )
}

TilePerson.propTypes = {
  rootStyle: PropTypes.string,
  tile: PropTypes.object.isRequired,
}

export default TilePerson
